import React from 'react';
import AccountActions from "./AccountActions";
import Title from "../../../components/Title";

const UserAccount = () => {

    return (
        <>
            <Title title="Octoopi Cocpit | Kullanıcı İşlemleri" description="Mertech Arge A.Ş Kullanıcı İşlemleri"/>
            <AccountActions/>
        </>
    );
};

export default UserAccount;
